import { FC } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import { HeroSection as HeroSectionType } from "../config/landing.config";
import { useNavigate } from "react-router-dom";
import HeaderLanding from "../../../components/template/HeaderLanding/HeaderLanding";
import { secondaryColor } from "../../../utils/colors";

interface HeroSectionProps {
  config: HeroSectionType;
}

export const HeroSection: FC<HeroSectionProps> = ({ config }) => {
  const navigate = useNavigate();

  return (
    <Box
      position="relative"
      color="white"
      overflowX="hidden" // evita qualquer overflow do hero
      style={{
        backgroundImage: `url('${config.backgroundImage}')`,
        // backgroundSize: "100% 100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <HeaderLanding />
      {/* <Container maxW="100%" px={{ base: 8, md: 16, lg: 24 }}> */}
      <Container maxW="100%" overflow="hidden" px={{ base: 4, md: 16, lg: 24 }}  pt={{ base: "96px", md: "112px" }} >
        <Flex
          direction={{ base: "column", lg: "row" }}
          gap={{ base: 8, lg: 16 }}
          alignItems="center"
          justify="space-between"
          position="relative"
          height="100%"
        >
          {/* <Box maxW="50%" padding="24"> */}
          <Box
            w={{ base: "100%", lg: "50%" }}
            maxW={{ base: "100%", lg: "50%" }}
            padding={{ base: 4, md: 12, lg: 24 }}
          >
            <Text
              color={secondaryColor}
              fontSize="4xl"
              fontWeight="bold"
              mb={4}
            >
              {config.title}
            </Text>
            <Heading
              as="h1"
              fontSize="6xl"
              sx={{
                "@media (max-width: 1800px)": {
                  fontSize: "5xl",
                },
                "@media (max-width: 1400px)": {
                  fontSize: "4xl",
                },
              }}
              lineHeight="1.2"
              fontWeight="bold"
              mb={8}
            >
              {config.subtitle}
            </Heading>
            <Button
              variant="secondary"
              bg="white"
              onClick={() => navigate(config.ctaButton.href)}
            >
              {config.ctaButton.text}
            </Button>
          </Box>

          {/* <Image
            src={config.heroImage.src}
            alt={config.heroImage.alt}
            position="absolute"
            right={0}
            top={0}
            boxShadow="0px 2px 10px rgba(0, 0, 0, 0.3)"
            maxH="730px"
            sx={{
              "@media (max-width: 1800px)": {
                maxHeight: "600px",
              },
              "@media (max-width: 1400px)": {
                maxHeight: "550px",
              },
            }}
            borderRadius={16}
          /> */}
          <Image
            src={config.heroImage.src}
            alt={config.heroImage.alt}
            boxShadow="0px 2px 10px rgba(0, 0, 0, 0.3)"
            borderRadius={16}
            maxH={{
              base: "280px",
              sm: "340px",
              md: "420px",
              lg: "550px",
              xl: "650px",
            }}
            width="auto"
            position={{ base: "static", lg: "absolute" }}
            right={{ lg: 0 }}
            top={{ lg: 0 }}
          />
        </Flex>
      </Container>
    </Box>
  );
};
